"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_table_1 = require("react-table");
var Table_1 = __importDefault(require("@mui/material/Table"));
var material_1 = require("@mui/material");
var Table = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.hoverable, hoverable = _c === void 0 ? false : _c, _d = _a.hiddenColumns, hiddenColumns = _d === void 0 ? [] : _d, passedPageSize = _a.passedPageSize, data = _a.data, columns = _a.columns, _e = _a.globalFilterSearch, globalFilterSearch = _e === void 0 ? '' : _e, _f = _a.defaultSortAccessor, defaultSortAccessor = _f === void 0 ? '' : _f, _g = _a.sortDesc, sortDesc = _g === void 0 ? false : _g, onRowClick = _a.onRowClick;
    var memodata = (0, react_1.useMemo)(function () { return data; }, [data]);
    var memoColumns = (0, react_1.useMemo)(function () { return columns; }, [columns]);
    var _h = (0, react_table_1.useTable)({
        columns: memoColumns,
        data: memodata,
        autoResetSortBy: false,
        autoResetPage: false,
        autoResetRowState: false,
        initialState: {
            pageIndex: 0,
            pageSize: passedPageSize,
            // eslint-disable-next-line array-callback-return
            hiddenColumns: columns.map(function (column) {
                if (column.show === false)
                    return column.accessor || column.id;
            }),
            sortBy: [
                {
                    id: defaultSortAccessor,
                    desc: sortDesc,
                },
            ],
        },
    }, react_table_1.useFilters, react_table_1.useGlobalFilter, react_table_1.useSortBy, react_table_1.usePagination), getTableProps = _h.getTableProps, getTableBodyProps = _h.getTableBodyProps, headerGroups = _h.headerGroups, page = _h.page, setGlobalFilter = _h.setGlobalFilter, setPageSize = _h.setPageSize, prepareRow = _h.prepareRow, pageCount = _h.pageCount, gotoPage = _h.gotoPage, pageIndex = _h.state.pageIndex;
    (0, react_1.useEffect)(function () { return setPageSize(passedPageSize); }, [passedPageSize, setPageSize]);
    (0, react_1.useEffect)(function () {
        setGlobalFilter(globalFilterSearch);
    }, [globalFilterSearch, setGlobalFilter]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Table_1.default, __assign({}, getTableProps(), { size: size, sx: {
                    borderCollapse: size === 'medium' ? 'separate' : 'initial',
                    borderSpacing: size === 'medium' ? '0 1.6rem' : 'initial',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TableHead, { children: headerGroups.map(function (headerGroup) { return ((0, jsx_runtime_1.jsx)(material_1.TableRow, __assign({}, headerGroup.getHeaderGroupProps(), { children: headerGroup.headers.map(function (column) { return ((0, jsx_runtime_1.jsx)(material_1.TableCell, __assign({}, column.getHeaderProps(), { size: size, sx: {
                                    fontSize: '1.6rem',
                                    fontWeight: 'normal',
                                    lineHeight: '1.5rem',
                                } }, { children: column.render('Header') }))); }) }))); }) }), (0, jsx_runtime_1.jsx)(material_1.TableBody, __assign({}, getTableBodyProps(), { children: page.map(function (row, i) {
                            prepareRow(row);
                            return ((0, jsx_runtime_1.jsx)(material_1.TableRow, __assign({ sx: {
                                    cursor: 'pointer',
                                    borderRadius: '20px',
                                }, hover: hoverable }, row.getRowProps({ onClick: function () { return onRowClick(row); } }), { children: row.cells.map(function (cell, index) {
                                    return ((0, jsx_runtime_1.jsx)(material_1.TableCell, __assign({}, cell.getCellProps(), { size: size, sx: (!index && {
                                            borderTopLeftRadius: '20px',
                                            borderBottomLeftRadius: '20px',
                                        }) ||
                                            (index === row.cells.length - 1 && {
                                                borderTopRightRadius: '20px',
                                                borderBottomRightRadius: '20px',
                                            }) }, { children: cell.render('Cell') })));
                                }) }), i));
                        }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '4rem', display: 'flex', justifyContent: 'center' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Pagination, { count: pageCount, page: pageIndex + 1, onChange: function (e, index) {
                        gotoPage(index - 1);
                    }, color: "secondary", sx: {
                        '.MuiPaginationItem-text': {
                            color: 'primary.400',
                        },
                        '.Mui-selected': {
                            color: 'primary.600',
                        },
                    } }) }))] }));
};
exports.default = Table;
